module.exports = __webpack_public_path__ + "static/media/o_configurator_mobile.b0c73f04.jpg";